module.exports = {
  'gdt.gradepro.org': 'http://gdt.guidelinedevelopment.org',
  'gdt.test.evidenceprime.com': 'https://gdt2.test.evidenceprime.com',
  'gdt.qa.evidenceprime.com': 'http://staging.gdt.evidenceprime.com',
  'edt.evidenceprime.com': 'http://icf.gdt.evidenceprime.com',
  'ec.gdt.evidenceprime.com': 'http://beta.gdt.evidenceprime.com',
  'new.gdt.local:3333': 'http://old.gdt.local:8080'
};
